import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { matchPaymentsAPI } from '@/lib/api';

/** Where Stripe sends a player after paying their share of the field. Public on purpose. */
export default function QuotaConfirmPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [state, setState] = useState({ status: 'loading' });

  useEffect(() => {
    if (!sessionId) {
      setState({ status: 'error', message: 'Link di pagamento non valido' });
      return;
    }
    matchPaymentsAPI.confirmQuota(sessionId)
      .then((res) => setState({ status: 'success', matchId: res.data.match_id, held: res.data.status === 'held' }))
      .catch((err) => setState({ status: 'error', message: err.response?.data?.detail || 'Non riesco a verificare il pagamento' }));
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="w-full max-w-sm">
        <CardContent className="py-10 flex flex-col items-center gap-4 text-center">
          {state.status === 'loading' && (
            <>
              <Loader2 className="h-14 w-14 animate-spin text-primary" />
              <p className="text-muted-foreground">Verifico il pagamento…</p>
            </>
          )}
          {state.status === 'success' && (
            <>
              <CheckCircle2 className="h-14 w-14 text-emerald-500" />
              <h1 className="text-xl font-bold">{state.held ? 'Quota bloccata!' : 'Quota pagata!'}</h1>
              <p className="text-sm text-muted-foreground">
                {state.held
                  ? "Per ora non ti è stato addebitato nulla: un'ora prima della partita paghi la quota giusta."
                  : 'La tua quota del campo è arrivata.'}
                {' '}Se sei nell'app, chiudi questa finestra per tornare alla partita.
              </p>
              {!Capacitor.isNativePlatform() && state.matchId && (
                <Button asChild>
                  <Link to={`/matches/${state.matchId}`}>Torna alla partita</Link>
                </Button>
              )}
            </>
          )}
          {state.status === 'error' && (
            <>
              <XCircle className="h-14 w-14 text-red-500" />
              <p className="text-sm text-muted-foreground">{state.message}</p>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
